import { Observable } from "rxjs";
import { InitService, Product, ProductKey, Products } from "gast-common-ng2";
import { DestroyRef, inject } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { PORTAL_PRODUCT_SHOW_QUERY_PARAM_TOKEN, PortalQueryParams } from "../../../constants";

export abstract class PortalProductStrategy {
  protected readonly initService = inject(InitService);
  protected readonly destroyRef = inject(DestroyRef);
  protected readonly router = inject(Router);
  protected readonly SHOW_PRODUCT_ID_IN_BROWSER_URL = inject(PORTAL_PRODUCT_SHOW_QUERY_PARAM_TOKEN);

  abstract availableProducts$: Observable<ProductKey[]>;
  abstract selectedProduct$: Observable<ProductKey>;
  abstract availableProductsAsString$: Observable<string[]>;
  abstract selectedProductAsString$: Observable<string>;
  abstract updateCurrentProduct(productToSet: string): void;

  protected subscribeToProductUpdated(): void {
    this.selectedProduct$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((productKey: ProductKey) => {
      const productId: Product = Products[productKey];
      this.initService.setProductId(productId);
      if (this.SHOW_PRODUCT_ID_IN_BROWSER_URL) {
        this.appendProductParamToBrowserUrl(productId);
      }
    });
  }

  protected appendProductParamToBrowserUrl(productId: Product): void {
    const options: NavigationExtras = {
      queryParams: { [PortalQueryParams.PRODUCT_ID]: productId },
      queryParamsHandling: "merge",
      preserveFragment: true,
    };
    this.router.navigate([], options).then(() => Promise.resolve());
  }
}
